import React from "react";
import "./App.css";
import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Locations from "./components/Locations";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <TopBar />
      <Navbar />
      <Hero />
      <Services />
      <Locations />
      <WhyChooseUs />
      <Testimonials />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
